import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ContactMessage } from '../models/ContactMessage';

import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'] // یا contact.component.scss اگر از SCSS استفاده می‌کنید
})
export class ContactComponent implements OnInit {
  contactForm!: FormGroup;
  submissionStatus: 'idle' | 'sending' | 'success' | 'error' = 'idle';
  serverErrors: { [key: string]: string } = {}; // برای نمایش خطاهای سرور

  // فرض بر این است که baseUrl در جایی تعریف شده است، مثلاً در یک سرویس یا environment file
  // به عنوان مثال: private baseUrl = environment.apiBaseUrl;
  // private baseUrl = '/api'; // مثال: مسیر API شما ممکن است متفاوت باشد
  baseUrl = environment.apiBaseUrl;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.contactForm = this.fb.group({
      // برای نام، ایمیل و پیام، هم الزامی بودن و هم فرمت را چک می‌کنیم
      name: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(100)]],
      message: ['', [Validators.required, Validators.maxLength(500)]]
    });
  }

  // تابع کمکی برای دسترسی آسان‌تر به کنترل‌ها در تمپلیت
  get formControls(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }

  onSubmit(): void {
    if (this.contactForm.invalid) {
      // اگر فرم نامعتبر است، فقط فیلدهایی که خطا دارند را markAsTouched می‌کنیم تا پیام‌های خطا نمایش داده شوند
      this.contactForm.markAllAsTouched();
      this.serverErrors = {}; // خطاهای سرور قبلی را پاک می‌کنیم
      return;
    }

    this.submissionStatus = 'sending';
    this.serverErrors = {}; // پاک کردن خطاهای قبلی قبل از ارسال درخواست جدید

    const contactData = this.contactForm.value;

    // ارسال درخواست POST به API
    this.http.post(`${this.baseUrl}/contact`, contactData)
      .pipe(
        tap(() => {
          // در صورت موفقیت
          this.submissionStatus = 'success';
          this.contactForm.reset(); // فرم را ریست می‌کنیم
          // می‌توانید یک پیام موفقیت‌آمیز به کاربر نشان دهید یا او را به صفحه دیگری هدایت کنید
          console.log('پیام با موفقیت ارسال شد.');
        }),
        catchError((error: HttpErrorResponse) => this.handleError(error))
      )
      .subscribe(); // subscribe برای فعال کردن observable
  }

  handleError(error: HttpErrorResponse): Observable<never> {
    this.submissionStatus = 'error';
    if (error.status === 400 && error.error?.errors) {
      // خطاهای اعتبارسنجی از سرور ( ModelState )
      this.serverErrors = {};
      for (const key in error.error.errors) {
        // کلیدها ممکن است به صورت "name", "email", "message" یا "ModelState['name']" باشند
        // ما فقط نام فیلد را استخراج می‌کنیم
        const fieldName = key.replace('ModelState[', '').replace(']', '').toLowerCase();
        if (this.contactForm.controls[fieldName]) {
          // خطای مربوط به فیلد را پیدا کرده و نمایش می‌دهیم
           this.contactForm.controls[fieldName].setErrors({ serverError: error.error.errors[key][0] });
        }
      }
      console.error('خطاهای اعتبارسنجی سرور:', error.error.errors);
    } else {
      // خطاهای عمومی سرور یا شبکه
      console.error('خطا در ارسال پیام:', error);
      // می‌توانید یک پیام خطای عمومی به کاربر نشان دهید
      this.serverErrors = { general: 'خطای غیرمنتظره‌ای رخ داد. لطفاً بعداً دوباره امتحان کنید.' };
    }
    // throwError را برای اینکه catchError ادامه یابد، برمی‌گردانیم
    return throwError(() => new Error('خطا در ارسال پیام'));
  }

}
